import { render, staticRenderFns } from "./rotterdam.vue?vue&type=template&id=6b7876f6"
import script from "./rotterdam.vue?vue&type=script&lang=js"
export * from "./rotterdam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports